// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createBtn {
    background-color: #285D54 !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: #FFFFFF !important;
    padding: 0.8rem 1rem 0.8rem 1rem !important;
    border: none !important;
    cursor: pointer !important;
}

.cancelBtn {
    background-color: #FFFFFF !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: #285D54 !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.btnContent {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    color: white !important;
}

.listHeader {
    font-size: 16px !important;
    color: black !important;
    font-weight: 900 !important;
}

.contentLeft {
    font-size: 16px !important;
    color: black !important;
    font-weight: 900 !important;
}

.contentRight {
    font-size: 16px !important;
    color: black !important;
    font-weight: 500 !important;
}

.labelContent {
    font-size: 16px !important;
    color: black !important;
    font-weight: 900 !important;
    padding-top: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/userManagement/userType/userType.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC","sourcesContent":[".createBtn {\n    background-color: #285D54 !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: #FFFFFF !important;\n    padding: 0.8rem 1rem 0.8rem 1rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.cancelBtn {\n    background-color: #FFFFFF !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: #285D54 !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.btnContent {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    color: white !important;\n}\n\n.listHeader {\n    font-size: 16px !important;\n    color: black !important;\n    font-weight: 900 !important;\n}\n\n.contentLeft {\n    font-size: 16px !important;\n    color: black !important;\n    font-weight: 900 !important;\n}\n\n.contentRight {\n    font-size: 16px !important;\n    color: black !important;\n    font-weight: 500 !important;\n}\n\n.labelContent {\n    font-size: 16px !important;\n    color: black !important;\n    font-weight: 900 !important;\n    padding-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
